import React from 'react';
import { Notifier } from '@airbrake/browser';
import ErrorPage from '../components/ErrorPage';
import PropTypes from 'prop-types';

const isAirbrakeConfigured = () => window.AIRBRAKE_REACT_PROJECT_ID && window.AIRBRAKE_REACT_PROJECT_KEY && window.AIRBRAKE_ENVIRONMENT;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };

    if (isAirbrakeConfigured()) {
      this.airbrake = new Notifier({
        projectId: window.AIRBRAKE_REACT_PROJECT_ID,
        projectKey: window.AIRBRAKE_REACT_PROJECT_KEY,
        environment: window.AIRBRAKE_ENVIRONMENT,
      });
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });

    if (isAirbrakeConfigured()) {
      this.airbrake.notify({
        error: error,
        params: {info: info},
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
